// extracted by mini-css-extract-plugin
export default {"amenities":"amenities-nSgpQ","amenity":"amenity-uxEuv","info":"info-vBuFy"};